<template>
  <div>
    <b-row class="pb-3">
      <!-- year select -->
      <b-col cols="3">
        <b-input-group>
          <b-form-select v-model="selectedYear" id="yearSelected" :options="yearOptions"></b-form-select>
          <b-form-select style="margin-left:10px" v-model="selectedClass" id="classSelected"
            :options="classOptions"></b-form-select>
        </b-input-group>
      </b-col>
    </b-row>
    <!-- Loading -->
    <b-row v-if="isLoading">
      <b-col>
        <LoadingSpinner></LoadingSpinner>
      </b-col>
    </b-row>
    <!-- Table -->
    <b-row v-if="!isLoading">
      <b-col>
        <b-card no-body>
          <b-table hover :items="inscripciones" :fields="inscripcionesFields">
            <template #cell(x_student_id)="data">
              <b-button variant="link" @click="gotoFamilia(data.item)">{{ data.item.x_student_id[1] }}</b-button>
            </template>
            <template #cell(x_class_id)="data">
              {{ data.item.x_class_id[1] }}
            </template>
            <template #cell(x_invoice_id)="data">
              {{ data.item.x_invoice_id[1] }}
            </template>
            <template #cell(x_sale_order_id)="data">
              {{ data.item.x_sale_order_id[1] }}
            </template>
            <template #cell(x_status)="data">
              <b-badge>{{ data.item.x_status }}</b-badge>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <b-modal id="modal-ver-inscriptos" size="xl" title="Ver Inscriptos">
      <b-table :items="verInscriptosList" :fields="inscriptosFields">
        <template #cell(x_sale_order_id)="data">
          {{ data.item.x_sale_order_id[1] }}
        </template>
        <template #cell(x_student_id)="data">
          {{ data.item.x_student_id[1] }}
        </template>
        <template #cell(x_status)="data">
          <b-badge>{{ data.item.x_status }}</b-badge>
        </template>
        <template #cell(actions)="data">
          <b-dropdown right text="">
            <b-dropdown-item @click="data.toggleDetails">Expandir</b-dropdown-item>
            <b-dropdown-item @click="verVenta(data.item.x_sale_order_id[1])">Ver Venta</b-dropdown-item>
            <b-dropdown-item @click="verFamilia(data.item)">Ver Familia</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="onDemandCreateDraftInvoices(data.item)">Generar Facturas</b-dropdown-item>
          </b-dropdown>
        </template>
        <template #row-details="data">
          <b-card>

            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Data:</b></b-col>
              <b-col>{{ data }}</b-col>
            </b-row>

            <b-button size="sm" @click="data.toggleDetails">Hide Details</b-button>
          </b-card>
        </template>
        <template #modal-footer="{ cancel }">
          <b-button @click="cancel()">
            Cerrar
          </b-button>
        </template>
      </b-table>
    </b-modal>
    <b-modal id="modal-ver-venta" size="xl" :title="modalSaleOrderTitle">
      <ver-venta :order_id="modalSaleOrderId"></ver-venta>
    </b-modal>
  </div>
</template>

<script>
import VerVenta from './VerVenta.vue'
// import { YearsService } from '@/services/years.service'
import { FamiliesService } from '@/services/families.service'
// import { ClassesService } from '@/services/classes.service'
import { EnrollmentsService } from '@/services/enrollments.service'
// import { SaleOrdersService } from '@/services/sale.orders.service'
import LoadingSpinner from './../components/LoadingSpinner.vue'

export default {
  name: 'Clases',
  components: {
    VerVenta,
    LoadingSpinner
  },
  data () {
    return {
      isLoading: true,
      years: [],
      selectedYear: null,
      selectedClass: null,
      classes: [],
      inscripcionesFields: ['create_date', 'x_sale_order_id', 'x_student_id', 'x_class_id', 'x_status'],
      inscripciones: [],
      year: null,
      filter: '',
      verInscriptosList: [],
      inscriptosFields: [
        { key: 'create_date', label: 'Creacion', sortable: true, sortDirection: 'desc' },
        { key: 'x_sale_order_id', label: 'Venta', sortable: true, sortDirection: 'desc' },
        { key: 'x_student_id', label: 'Alumno' },
        { key: 'x_status', label: 'Estado' },
        { key: 'actions', label: 'Acciones' }
      ],
      modalSaleOrderTitle: '',
      modalSaleOrderId: null,
      searchFilter: ''
    }
  },
  watch: {
    async selectedYear (n, o) {
      this.inscripciones = await EnrollmentsService.list({ x_year_id: this.selectedYear }, [], { limit: 0, order: 'id desc' })
      console.log(this.inscripciones)

      // this.classes =
      this.isLoading = false
    }
  },
  computed: {
    yearOptions () {
      const opts = []
      for (var i = 0; i < this.years.length; i++) {
        opts.push({ value: this.years[i].id, text: this.years[i].x_year })
      }
      return opts
    },
    classOptions () {
      const opts = []
      for (var i = 0; i < this.inscripciones.length; i++) {
        opts.push({ value: this.inscripciones[i].x_class_id[0], text: this.inscripciones[i].x_class_id[1] })
      }
      return opts
    }
  },
  async created () {
    this.years = this.$store.state.year.list
    this.year = this.$store.state.year.selected
    this.selectedYear = this.year.id
  },
  methods: {
    async gotoFamilia (item, newWindow = false) {
      const student = await FamiliesService.read([item.x_student_id[0]])
      if (newWindow) {
        window.open('/families/' + student[0].parent_id[0], '_blank')
      } else {
        this.$router.push({ path: '/families/' + student[0].parent_id[0] })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
